module.exports = __webpack_public_path__ + "img/de_pc.7141805c.png";